'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var organisationUnitLevelsInit = exports.organisationUnitLevelsInit = undefined;

exports.organisationUnitLevelsInit = organisationUnitLevelsInit = function organisationUnitLevelsInit(c) {
    var t = this,
        appManager = c.appManager,
        requestManager = c.requestManager,
        apiPath = appManager.getApiPath(),
        displayPropertyUrl = appManager.getDisplayPropertyUrl();

    return {
        baseUrl: apiPath + '/organisationUnitLevels.json',
        params: ['fields=id,displayName~rename(name),level', 'paging=false'],
        success: function success(r) {
            appManager.addOrganisationUnitLevels(r.organisationUnitLevels);

            if (!r.organisationUnitLevels.length) {
                alert('No organisation unit levels found');
            }

            requestManager.ok(this);
        }
    };
};
//# sourceMappingURL=organisationUnitLevelsInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/organisationUnitLevelsInit.js
 ** module id = 143
 ** module chunks = 0 1
 **/